module.exports = __webpack_public_path__ + "static/img/role-en.4bbf860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/role-en.png
// module id = SBFz
// module chunks = 1